const { connect } = require("react-redux");
const HomeView = require("../components/HomeView");

module.exports = connect(state => ({
    isAuthenticated: state.auth.isAuthenticated
}))(HomeView);



// WEBPACK FOOTER //
// ./src/routes/home/containers/HomeView.js